import { render, staticRenderFns } from "./BrandSubscribe.vue?vue&type=template&id=21f18368&scoped=true"
import script from "./BrandSubscribe.vue?vue&type=script&lang=js"
export * from "./BrandSubscribe.vue?vue&type=script&lang=js"
import style0 from "./BrandSubscribe.vue?vue&type=style&index=0&id=21f18368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f18368",
  null
  
)

export default component.exports